/* Microphone status box shared by exercise start screens and live tool pages. */
import { getMicError, startMic, useMicState } from '../../core/mic';
import { useSettings } from '../../core/store';
import { Btn } from '../../ui/Button';
import { MicLevelMeter } from '../../ui/widgets';

export function MicBlock({ text, screenNote }: { text?: string; screenNote?: string }) {
  const st = useMicState();
  const { headphones } = useSettings();
  if (st === 'on')
    return (
      <div className="mic-block">
        <div className="mb-row">
          <span className="mb-dot on" />
          <strong>Mikrofon açık</strong>
          <span className="mb-sp" />
          <MicLevelMeter />
        </div>
        {!headphones ? (
          <p className="mb-note">
            İpucu: Kulaklık takarsan uygulamanın sesi mikrofona karışmaz. Takmıyorsan, ses çalarken mikrofon kısa bir
            süre dinlemeyi bırakır.
          </p>
        ) : null}
      </div>
    );
  const msg =
    st === 'denied'
      ? 'Mikrofon izni verilmedi. Tarayıcının adres çubuğundaki izin simgesinden açabilirsin.'
      : st === 'unavailable'
        ? 'Bu tarayıcı ya da bağlantı mikrofona izin vermiyor (HTTPS veya yerel dosya gerekir).'
        : st === 'nodevice'
          ? 'Bağlı bir mikrofon bulunamadı.'
          : st === 'error'
            ? `Mikrofon açılamadı: ${getMicError()?.message || 'bilinmeyen hata'}`
            : text || 'Çaldığını ya da söylediğini duyabilmem için mikrofonu aç.';
  return (
    <div className="mic-block">
      <div className="mb-row">
        <span className="mb-dot" />
        <strong>{st === 'starting' ? 'Mikrofon açılıyor…' : 'Mikrofon kapalı'}</strong>
      </div>
      <p className="mb-note">{msg}</p>
      <div className="mb-actions">
        <Btn kind="primary" icon="mic" onClick={() => startMic()}>
          Mikrofonu aç
        </Btn>
        {screenNote ? <span className="mb-or">{screenNote}</span> : null}
      </div>
    </div>
  );
}

/** Shows the mic block only while the microphone is off (for live tool pages). */
export function MicGate({ text }: { text: string }) {
  const st = useMicState();
  return st === 'on' ? null : <MicBlock text={text} />;
}
